<template>
  <div class="bg-pattern-gray">
    <!-- Button to trigger email PDF -->
    <div class="float-start mb-3">
      <button class="btn btn-success btn-big _3d-input" @click="handleBack">
        Back
      </button>
    </div>
    <div class="float-end mb-3 d-flex align-items-center gap-2">
      <el-dropdown v-if="invoice_data && invoice_data.invoice_status" @command="handleCommandDropdown">
        <span class="el-dropdown-link"
          style="cursor: pointer; padding: 10px; border: 1px solid #ddd; border-radius: 4px; background: white;">
          <i class="fas fa-ellipsis-v"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- DRAFT only: Save, Edit, Delete -->
            <!-- <el-dropdown-item v-if="isDraft" command="save"><i class="fa fa-save"></i> Save</el-dropdown-item> -->
            <el-dropdown-item v-if="isDraft" command="edit"><i class="fa fa-edit"></i> Edit</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="delete"><i class="fa fa-trash"></i> Delete</el-dropdown-item>
            <!-- SENT only: Void -->
            <el-dropdown-item v-if="isSent" command="void"><i class="fa fa-ban"></i> Void</el-dropdown-item>
            <!-- Always: Make Copy, Download, Print, Convert to Quotation -->
            <el-dropdown-item command="copy"><i class="fa fa-copy"></i> Make Copy</el-dropdown-item>
            <!-- <el-dropdown-item command="download"><i class="fa fa-download"></i> Download</el-dropdown-item> -->
            <!-- <el-dropdown-item command="print"><i class="fa fa-print"></i> Print</el-dropdown-item> -->
            <el-dropdown-item command="convert"><i class="fa fa-exchange-alt"></i> Convert to
              Quotation</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <button class="btn btn-success btn-big _3d-input" @click="sendEmail">
        Email Invoice
      </button>
    </div>
    <iframe v-if="pdfUrl" :src="pdfUrl" width="100%" height="1200px" frameborder="0"></iframe>
    <div v-else class="alert alert-warning my-3" role="alert">
      The PDF preview is not available yet for this invoice.
      <button class="btn btn-link p-0 align-baseline" @click="editDataPopulate">Reload</button>
    </div>
    <div class="d-flex justify-content-end mb-3 align-items-center">
      <!-- Button to trigger email PDF -->
      <button class="btn btn-success btn-big _3d-input me-2" @click="sendEmail">
        Email Invoice
      </button>

      <el-dropdown v-if="invoice_data && invoice_data.invoice_status" @command="handleCommandDropdown">
        <span class="el-dropdown-link"
          style="cursor: pointer; padding: 10px; border: 1px solid #ddd; border-radius: 4px; background: white;">
          <i class="fas fa-ellipsis-v"></i>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- DRAFT only: Save, Edit, Delete -->
            <el-dropdown-item v-if="isDraft" command="save"><i class="fa fa-save"></i> Save</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="edit"><i class="fa fa-edit"></i> Edit</el-dropdown-item>
            <el-dropdown-item v-if="isDraft" command="delete"><i class="fa fa-trash"></i> Delete</el-dropdown-item>
            <!-- SENT only: Void -->
            <el-dropdown-item v-if="isSent" command="void"><i class="fa fa-ban"></i> Void</el-dropdown-item>
            <!-- Always: Make Copy, Download, Print, Convert to Quotation -->
            <el-dropdown-item command="copy"><i class="fa fa-copy"></i> Make Copy</el-dropdown-item>
            <el-dropdown-item command="download"><i class="fa fa-download"></i> Download</el-dropdown-item>
            <el-dropdown-item command="print"><i class="fa fa-print"></i> Print</el-dropdown-item>
            <el-dropdown-item command="convert"><i class="fa fa-exchange-alt"></i> Convert to
              Quotation</el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
  </div>
</template>

<script>
import { ElMessageBox } from 'element-plus';
import { resolveApiAssetUrl } from '../../config/url';

export default {
  name: "AddInvoice",
  props: {
    title: String,
    // rest of the blog post props
  },
  data() {
    return {
      pdfUrl: "",
      invoice_data: "",
      invoice_number: "",
      cameFromCreate: false,
    };
  },
  created() {
    this.cameFromCreate = this.$route.query.from === 'create';
    // Clean up the query param so it doesn't persist in URL
    if (this.cameFromCreate) {
      this.$router.replace({
        ...this.$route,
        query: { ...this.$route.query, from: undefined },
      });
    }
    this.editDataPopulate();
  },
  computed: {
    pageTitle() {
      return (document.title = `${this.title.replace(/\b\w/g, (match) =>
        match.toUpperCase()
      )} | Smoothbalance`);
    },
    isDraft() {
      return this.invoice_data && this.invoice_data.invoice_status === 'draft';
    },
    isSent() {
      return this.invoice_data && this.invoice_data.invoice_status === 'sent';
    },
    isVoid() {
      return this.invoice_data && this.invoice_data.invoice_status === 'void';
    },
  },
  methods: {
    handleBack() {
      if (this.isDraft) {
        ElMessageBox.alert(
          'The invoice has been saved as a draft.',
          'Invoice Saved',
          {
            confirmButtonText: 'OK',
            type: 'success',
          }
        ).then(() => {
          this.$router.push({ name: 'edit-invoice', params: { id: this.invoice_number } });
        });
      } else {
        this.$router.push({ name: 'edit-invoice', params: { id: this.invoice_number } });
      }
    },
    sendEmail() {
      this.$store
        .dispatch("invoice/sendEmail", { invoice_number: this.invoice_number })
        .then((res) => {
          if (res.data.status == 1) {
            this.$toast.success("Email sent successfully");
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        });
    },
    handleCommandDropdown(command) {
      if (command === 'save') {
        this.$toast.info("Save functionality will be implemented soon.");
      } else if (command === 'edit') {
        this.$router.push({ name: 'edit-invoice', params: { id: this.invoice_number } });
      } else if (command === 'delete') {
        this.$toast.info("Delete functionality will be implemented soon.");
      } else if (command === 'void') {
        this.$toast.info("Void functionality will be implemented soon.");
      } else if (command === 'payment') {
        this.$toast.info("Payment functionality will be implemented soon.");
      } else if (command === 'copy') {
        const iNumber = this.invoice_number || this.$route.params.id;
        if (!iNumber) {
          this.$toast.error("Invoice number not available.");
          return;
        }
        this.$router.push(`/copy-invoice/${iNumber}`);
      } else if (command === 'download') {
        if (this.pdfUrl) {
          window.open(this.pdfUrl, '_blank');
        } else {
          this.$toast.error("PDF is not available for download.");
        }
      } else if (command === 'print') {
        const iframe = document.querySelector('iframe');
        if (iframe && iframe.contentWindow) {
          iframe.contentWindow.print();
        } else {
          this.$toast.error("Unable to print PDF preview.");
        }
      } else if (command === 'convert') {
        const iNumber = this.invoice_number || this.$route.params.id;
        if (!iNumber) {
          this.$toast.error("Invoice number not available.");
          return;
        }
        this.$router.push(`/convert-invoice/${iNumber}`);
      }
    },
    showLoading() {
      this.loadingInstance = this.$loading({
        lock: true,
        text: "Loading",
        background: "rgba(0, 0, 0, 0.7)",
        fullscreen: true,
      });
    },
    hideLoading() {
      this.loadingInstance.close();
    },
    editDataPopulate() {
      this.showLoading();
      const routeId = this.$route.params.id;
      this.invoice_number = routeId;

      this.$store
        .dispatch("invoice/getInvoiceByNumber", { invoice_number: this.invoice_number })
        .then((res) => {
          // console.log(res.data.response);

          if (res.data.status == 1) {
            this.invoice_data = res.data.response;
            this.invoice_number = res.data.response.invoice_number;
            this.pdfUrl = resolveApiAssetUrl(res.data.response.pdfLink);
          } else {
            throw new Error(res);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error("Something went wrong. Please try again.");
        })
        .finally(() => {
          this.hideLoading();
        });
    },
  },
};
</script>
